<ng-template #eersteSchade>Bij de 1e schademelding</ng-template>
<ng-template #ruitreparatie>Ruitreparatie</ng-template>
<ng-template #ruitvervanging>Ruitvervanging</ng-template>
<ng-template #totalLoss>Bij total loss of diefstal van auto en/of autosleutels</ng-template>
<ng-template #andereSchade>Bij andere schade aan de auto</ng-template>

<ng-template #voorwaardenAuto>
    <!-- prettier-ignore -->
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsCarInsurance" pdfLinkTitle="Voorwaarden Autoverzekering">in
            onze voorwaarden</ins-pdf-link>.
    </p>
</ng-template>

<ng-container *ngIf="coverageId === coverageIdEnum.WA">
    <wuc-tabset tabsetStyle="secondary">
        <wuc-tabset-item name="Wel verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Schade die u of een andere bestuurder veroorzaakt aan anderen:</p>
                    <wuc-list icon="check">
                        <wuc-list-item>Met uw auto</wuc-list-item>
                        <wuc-list-item>In het verkeer met een aanhangwagen die aan uw auto is gekoppeld</wuc-list-item>
                        <wuc-list-item>door lading die van uw auto afvalt</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>Ook krijgt u:</p>
                    <wuc-list icon="check">
                        <wuc-list-item>
                            Juridische hulp bij het verhalen van schade aan uw auto als iemand anders aansprakelijk is
                            voor uw schade
                        </wuc-list-item>
                        <wuc-list-item>Hulp bij een ongeval als u niet verder kunt rijden</wuc-list-item>
                    </wuc-list>
                </div>
                <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Niet verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <wuc-list icon="dot">
                        <wuc-list-item>Schade aan uw eigen auto</wuc-list-item>
                        <wuc-list-item>Schade aan de bestuurder van uw auto</wuc-list-item>
                        <wuc-list-item>Schade aan de lading en bagage die met de auto vervoerd werd</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>En niet verzekerd is:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>
                            Schade tijdens zakelijk gebruik, verhuur of lease van uw auto aan een ander
                        </wuc-list-item>
                        <wuc-list-item>
                            Als het kenteken niet op uw naam of naam van uw partner (zelfde adres) staat
                        </wuc-list-item>
                        <wuc-list-item>Schade als uw auto gebruikt wordt bij een wedstrijd</wuc-list-item>
                        <wuc-list-item>U meer alcohol had gedronken dat wettelijk is toegestaan</wuc-list-item>
                        <wuc-list-item>
                            Als u geen geldig rijbewijs had of de schade met opzet heeft veroorzaakt
                        </wuc-list-item>
                        <wuc-list-item>Als iemand uw auto gebruikte zonder uw toestemming</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>
                        Soms verplicht de wet ons dat wij de schade aan een ander wel moeten betalen. U moet de schade
                        aan ons terugbetalen.
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Verzekerde bedragen">
            <wuc-rack gridGap="medium">
                <wuc-list icon="dot">
                    <wuc-list-item>€&nbsp;6.500.000 voor schade aan andere personen</wuc-list-item>
                    <wuc-list-item>€&nbsp;2.500.000 voor schade aan spullen van andere personen</wuc-list-item>
                </wuc-list>
                <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Eigen Risico">
            <p class="no-brake">€&nbsp;0</p>
            <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
        </wuc-tabset-item>
    </wuc-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.BeperktCasco">
    <wuc-tabset tabsetStyle="secondary">
        <wuc-tabset-item name="Wel verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Schade aan uw auto door:</p>
                    <wuc-list icon="check">
                        <wuc-list-item>(Poging tot) inbraak, diefstal en joyriding</wuc-list-item>
                        <wuc-list-item>Brand, kortsluiting en ontploffing</wuc-list-item>
                        <wuc-list-item>Storm, blikseminslag, hagel en overstroming</wuc-list-item>
                        <wuc-list-item>Botsing met vogels of loslopende dieren</wuc-list-item>
                        <wuc-list-item>Ruitschade</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>
                        De Beperkt Casco sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                        verzekering.
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Niet verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Schade aan uw eigen auto door:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Een aanrijding, parkeren of uw eigen schuld</wuc-list-item>
                        <wuc-list-item>Slijtage of slecht onderhoud</wuc-list-item>
                        <wuc-list-item>Normaal gebruik. Denk aan vuil, kleine putjes of schrammen</wuc-list-item>
                        <wuc-list-item>Bevriezing</wuc-list-item>
                        <wuc-list-item>Fouten in onderdelen of de constructie (zonder ongeval)</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>En niet verzekerd is:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>
                            Schade tijdens zakelijk gebruik, verhuur of lease van uw auto aan een ander
                        </wuc-list-item>
                        <wuc-list-item>
                            Als het kenteken niet op uw naam of naam van uw partner (zelfde adres) staat
                        </wuc-list-item>
                        <wuc-list-item>Schade als uw auto gebruikt wordt bij een wedstrijd</wuc-list-item>
                        <wuc-list-item>U meer alcohol had gedronken dat wettelijk is toegestaan</wuc-list-item>
                        <wuc-list-item>
                            Als u geen geldig rijbewijs had of de schade met opzet heeft veroorzaakt
                        </wuc-list-item>
                        <wuc-list-item>Als iemand uw auto gebruikte zonder uw toestemming</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>
                        Soms verplicht de wet ons dat wij de schade aan een ander wel moeten betalen. U moet de schade
                        aan ons terugbetalen.
                    </p>
                    <p>
                        De Beperkt Casco sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                        verzekering.
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Verzekerde bedragen">
            <wuc-rack gridGap="medium">
                <div>
                    <div class="h3">Verzekerde bedragen en de nieuw- en aanschafwaarderegeling:</div>
                    <wuc-list icon="dot">
                        <wuc-list-item>Bij schade aan uw auto maximaal de reparatiekosten</wuc-list-item>
                        <wuc-list-item>
                            Bij diefstal of totaal verlies van uw auto maximaal de:
                            <wuc-list icon="dot">
                                <wuc-list-item>De nieuwwaarde bij auto’s jonger dan 2 jaar</wuc-list-item>
                                <wuc-list-item>
                                    Aanschafwaarde tot 2 jaar na aankoop. En de auto gekocht is bij een bedrijf dat bij
                                    de Kamer van Koophandel staat ingeschreven als bedrijf dat handelt in personenauto’s
                                </wuc-list-item>
                                <wuc-list-item>
                                    Vervangingswaarde plus 10% (tot maximaal aanschafwaarde) in alle andere gevallen
                                </wuc-list-item>
                            </wuc-list>
                        </wuc-list-item>
                        <wuc-list-item>Accessoires tot €&nbsp;5.000</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>
                        De Beperkt Casco sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                        verzekering.
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Eigen Risico">
            <wuc-rack gridGap="medium">
                <wuc-table [isFullWidth]="true" [overflowScroll]="true">
                    <wuc-table-row border="bottom" [header]="true">
                        <wuc-table-cell></wuc-table-cell>
                        <wuc-table-cell position="center">InShared herstelbedrijf</wuc-table-cell>
                        <wuc-table-cell position="center">Ander herstelbedrijf</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Ruitreparatie</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;135</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Ruitvervanging</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;135</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;400</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Bij total loss of diefstal van auto en/of autosleutels</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Schade aan accessoires</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Bij andere schade aan de auto</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;135</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;400</wuc-table-cell>
                    </wuc-table-row>
                </wuc-table>
                <div>
                    <p>
                        Is een ander verantwoordelijk voor uw schade en kunnen wij die schade op de ander verhalen? Dan
                        betaalt u geen eigen risico.
                    </p>
                    <ng-container *ngTemplateOutlet="ownRisk"></ng-container>

                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
    </wuc-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.BeperktCascoExtra">
    <wuc-tabset tabsetStyle="secondary">
        <wuc-tabset-item name="Wel verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Schade aan uw auto door:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>(Poging tot) inbraak, diefstal en joyriding</wuc-list-item>
                        <wuc-list-item>Brand, kortsluiting en ontploffing</wuc-list-item>
                        <wuc-list-item>Storm, blikseminslag, hagel en overstroming</wuc-list-item>
                        <wuc-list-item>Botsing met vogels of loslopende dieren</wuc-list-item>
                        <wuc-list-item>Ruitschade</wuc-list-item>
                        <wuc-list-item>
                            Aanrijding, parkeren, vandalisme en eigen schuld (per ongeluk) tot 50% van de schade aan uw
                            auto
                        </wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>
                        De Beperkt Casco EXTRA sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van
                        de WA verzekering.
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Niet verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Schade aan uw eigen auto door:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Slijtage of slecht onderhoud</wuc-list-item>
                        <wuc-list-item>Normaal gebruik. Denk aan vuil, kleine putjes of schrammen</wuc-list-item>
                        <wuc-list-item>Bevriezing</wuc-list-item>
                        <wuc-list-item>Fouten in onderdelen of de constructie (zonder ongeval)</wuc-list-item>
                        <wuc-list-item>Een aanrijding, parkeren of uw eigen schuld voor 50%</wuc-list-item>
                        <wuc-list-item>
                            Dat u zelf ernstige schuld aan de schade heeft. Bijvoorbeeld veel te hard rijden op een
                            spiegelgladde weg of in dichte mist
                        </wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>En niet verzekerd is:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>
                            Schade tijdens zakelijk gebruik, verhuur of lease van uw auto aan een ander
                        </wuc-list-item>
                        <wuc-list-item>
                            Als het kenteken niet op uw naam of naam van uw partner (zelfde adres) staat
                        </wuc-list-item>
                        <wuc-list-item>Schade als uw auto gebruikt wordt bij een wedstrijd</wuc-list-item>
                        <wuc-list-item>U meer alcohol had gedronken dat wettelijk is toegestaan</wuc-list-item>
                        <wuc-list-item>
                            Als u geen geldig rijbewijs had of de schade met opzet heeft veroorzaakt
                        </wuc-list-item>
                        <wuc-list-item>Als iemand uw auto gebruikte zonder uw toestemming</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>
                        Soms verplicht de wet ons dat wij de schade aan een ander wel moeten betalen. U moet de schade
                        aan ons terugbetalen.
                    </p>
                    <p>
                        De Beperkt Casco EXTRA sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van
                        de WA verzekering.
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Verzekerde bedragen">
            <div class="h3">Verzekerde bedragen en de nieuw- en aanschafwaarderegeling:</div>

            <wuc-rack gridGap="medium">
                <wuc-list icon="dot">
                    <wuc-list-item>Bij schade aan uw auto maximaal de reparatiekosten</wuc-list-item>
                    <wuc-list-item>
                        Bij diefstal of totaal verlies van uw auto maximaal
                        <wuc-list icon="dot">
                            <wuc-list-item>De nieuwwaarde bij auto’s jonger dan 2 jaar</wuc-list-item>
                            <wuc-list-item>
                                Aanschafwaarde tot 2 jaar na aankoop. En de auto gekocht is bij een bedrijf dat bij de
                                Kamer van Koophandel staat ingeschreven als bedrijf dat handelt in personenauto’s
                            </wuc-list-item>
                            <wuc-list-item>
                                Vervangingswaarde plus 10% (tot maximaal aanschafwaarde) in alle andere gevallen
                            </wuc-list-item>
                        </wuc-list>
                    </wuc-list-item>
                    <wuc-list-item>
                        Schade bij aanrijding, parkeren of per ongeluk door eigen schuld ontstaan: maximaal 50% van de
                        aanschaf- of vervangingswaarde
                    </wuc-list-item>
                    <wuc-list-item>Accessoires tot €&nbsp;5.000</wuc-list-item>
                    <wuc-list-item>Medische kosten hond of kat na ongeluk tot €&nbsp;500</wuc-list-item>
                </wuc-list>
                <div>
                    <p>
                        De Beperkt Casco EXTRA sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van
                        de WA verzekering.
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Eigen Risico">
            <wuc-rack gridGap="medium">
                <wuc-table [isFullWidth]="true" [overflowScroll]="true">
                    <wuc-table-row border="bottom" [header]="true">
                        <wuc-table-cell></wuc-table-cell>
                        <wuc-table-cell position="center">InShared herstelbedrijf</wuc-table-cell>
                        <wuc-table-cell position="center">Ander herstelbedrijf</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Ruitreparatie</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;135</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Ruitvervanging</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;135</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;400</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Bij total loss of diefstal van auto en/of autosleutels</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Schade aan accessoires</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Bij andere schade aan de auto</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;400</wuc-table-cell>
                    </wuc-table-row>
                </wuc-table>
                <div>
                    <p>
                        Is een ander verantwoordelijk voor uw schade en kunnen wij die schade op de ander verhalen? Dan
                        betaalt u geen eigen risico.
                    </p>
                    <ng-container *ngTemplateOutlet="ownRisk"></ng-container>

                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
    </wuc-tabset>
</ng-container>
<ng-container *ngIf="coverageId === coverageIdEnum.Allrisk">
    <wuc-tabset tabsetStyle="secondary">
        <wuc-tabset-item name="Wel verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Schade aan uw auto door:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>(Poging tot) inbraak, diefstal en joyriding</wuc-list-item>
                        <wuc-list-item>Brand, kortsluiting en ontploffing</wuc-list-item>
                        <wuc-list-item>Storm, blikseminslag, hagel en overstroming</wuc-list-item>
                        <wuc-list-item>Botsing met vogels of loslopende dieren</wuc-list-item>
                        <wuc-list-item>Aanrijding, parkeren, vandalisme en eigen schuld (per ongeluk)</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>
                        De Allrisk sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                        verzekering.
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Niet verzekerd">
            <wuc-rack gridGap="medium">
                <div>
                    <p>Schade aan uw eigen auto door:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>Slijtage of slecht onderhoud</wuc-list-item>
                        <wuc-list-item>Fouten in onderdelen of de constructie (zonder ongeval)</wuc-list-item>
                        <wuc-list-item>Bevriezing</wuc-list-item>
                        <wuc-list-item>
                            Dat u zelf ernstige schuld aan de schade heeft. Bijvoorbeeld veel te hard rijden op een
                            spiegelgladde weg of in dichte mist
                        </wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>En niet verzekerd is:</p>
                    <wuc-list icon="dot">
                        <wuc-list-item>
                            Schade tijdens zakelijk gebruik, verhuur of lease van uw auto aan een ander
                        </wuc-list-item>
                        <wuc-list-item>
                            Als het kenteken niet op uw naam of naam van uw partner (zelfde adres) staat
                        </wuc-list-item>
                        <wuc-list-item>Schade als uw auto gebruikt wordt bij een wedstrijd</wuc-list-item>
                        <wuc-list-item>U meer alcohol had gedronken dat wettelijk is toegestaan</wuc-list-item>
                        <wuc-list-item>
                            Als u geen geldig rijbewijs had of de schade met opzet heeft veroorzaakt
                        </wuc-list-item>
                        <wuc-list-item>Als iemand uw auto gebruikte zonder uw toestemming</wuc-list-item>
                    </wuc-list>
                </div>
                <div>
                    <p>
                        Soms verplicht de wet ons dat wij de schade aan een ander wel moeten betalen. U moet de schade
                        aan ons terugbetalen.
                    </p>
                    <p>
                        De Allrisk sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                        verzekering.
                    </p>
                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Verzekerde bedragen">
            <div class="h3">Verzekerde bedragen en de aanschafwaarderegeling:</div>

            <wuc-rack gridGap="medium">
                <wuc-list icon="dot">
                    <wuc-list-item>Bij schade aan uw auto maximaal de reparatiekosten</wuc-list-item>
                    <wuc-list-item>
                        Bij diefstal of totaal verlies van uw auto maximaal
                        <wuc-list icon="dot">
                            <wuc-list-item>
                                Nieuwwaarde als de auto jonger dan 3 jaar is en u de 1e eigenaar bent
                            </wuc-list-item>
                            <wuc-list-item>
                                Aanschafwaarde bij tweedehands auto’s tot 3 jaar na aankoop. En de auto gekocht is bij
                                een bedrijf dat bij de Kamer van Koophandel staat ingeschreven als bedrijf dat handelt
                                in personenauto’s
                            </wuc-list-item>
                            <wuc-list-item>
                                Vervangingswaarde plus 10% in alle andere gevallen (tot maximaal aanschafwaarde)
                            </wuc-list-item>
                        </wuc-list>
                    </wuc-list-item>
                    <wuc-list-item>Accessoires tot €&nbsp;5.000</wuc-list-item>
                    <wuc-list-item>Medische kosten hond of kat na ongeluk tot €&nbsp;500</wuc-list-item>
                </wuc-list>
                <div>
                    <p>
                        De Allrisk sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                        verzekering.
                    </p>

                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
        <wuc-tabset-item name="Eigen Risico">
            <wuc-rack gridGap="medium">
                <wuc-table [isFullWidth]="true" [overflowScroll]="true">
                    <wuc-table-row border="bottom" [header]="true">
                        <wuc-table-cell></wuc-table-cell>
                        <wuc-table-cell position="center">InShared herstelbedrijf</wuc-table-cell>
                        <wuc-table-cell position="center">Ander herstelbedrijf</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Ruitreparatie</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;135</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Ruitvervanging</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;135</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;400</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Bij total loss of diefstal van auto en/of autosleutels</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Schade aan accessoires</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;0</wuc-table-cell>
                    </wuc-table-row>
                    <wuc-table-row border="bottom">
                        <wuc-table-cell>Bij andere schade aan de auto</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;135</wuc-table-cell>
                        <wuc-table-cell>€&nbsp;400</wuc-table-cell>
                    </wuc-table-row>
                </wuc-table>
                <div>
                    <p>
                        Is een ander verantwoordelijk voor uw schade en kunnen wij die schade op de ander verhalen? Dan
                        betaalt u geen eigen risico.
                    </p>
                    <ng-container *ngTemplateOutlet="ownRisk"></ng-container>

                    <ng-container *ngTemplateOutlet="voorwaardenAuto"></ng-container>
                </div>
            </wuc-rack>
        </wuc-tabset-item>
    </wuc-tabset>
</ng-container>

<ng-template #ownRisk>
    <p>
        <strong>InShared herstelbedrijf</strong>
        <br />
        Heeft u alleen ruitschade? Dan kunt u naar Autotaalglas of Carglass. Andere schade laat u vaststellen bij ABS
        Autoherstel. Daar kunt u de auto ook laten herstellen. Kiest u voor een eigen hersteller dan betaalt u een hoger
        eigen risico.
    </p>
</ng-template>
